import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Form, Row } from 'react-bootstrap';
import {
  TextLinkButton,
  Nowrap,
  Tooltip,
  FormInput,
  appActions,
  Beratungsverzicht,
  PersonAnredeFormRadio,
  PersonEmailFormInput,
  PersonGeburtsdatumFormMask,
  PersonNachnameFormInput,
  PersonTelefonFormInput,
  PersonTitelFormSelect,
  PersonVornameFormInput,
  SummingUp,
  SpeicherButton,
  PrevNextButton,
  useNextPage,
  useGotoPage,
  useUpdateAndValidateDateOnChange,
  useUpdateAndValidateOnChange,
  AdresseForm, Headline,
} from 'ion-lib';
import { getBannerFileName, setBeratersuche } from '../../helper';
import SummingupWarenkorb from '../../components/SummingupWarenkorb';

const Personendaten = () => {
  const validateDateOnChange = useUpdateAndValidateDateOnChange();
  const updateAndValidateOnChange = useUpdateAndValidateOnChange(0);
  const updateAndValidateTextOnChange = useUpdateAndValidateOnChange();

  const vn = useSelector((state) => state.daten.vn);
  const wagnis = useSelector((state) => state.daten.wagnis);
  const dispatch = useDispatch();

  const nextPage = useNextPage();
  const gotoPage = useGotoPage();

  const handleNextClick = () => {
    dispatch(appActions.serverValidationRequest('validiere', [
      'vn.anrede',
      'vn.titel',
      'vn.vorname',
      'vn.nachname',
      'vn.strasse',
      'vn.hausnummer',
      'vn.postleitzahl',
      'vn.ort',
      'vn.email',
      'vn.telefonNummer',
      'vn.geburtsdatum',
      'vn.staatsangehoerigkeit',
      'beratungsverzicht',
    ], () => {
      nextPage();
    }));
  };

  return (
    <Row>
      <Col>
        <div className="w-md spkpanel">
          <Beratungsverzicht
            onChange={updateAndValidateOnChange}
          />
          <Headline>Persönliche Daten</Headline>
          <Form.Group className="form-group">
            <Form.Label>
              Wer schließt die Versicherung für
              {' '}
              {wagnis.strasse.value}
              {' '}
              {wagnis.hnr.value}
              ,
              {' '}
              {wagnis.plz.value}
              {' '}
              {wagnis.ort.value}
              {' '}
              ab?
              <Nowrap>
                <Tooltip
                  handleTooltip={() => dispatch(appActions.toggleModal(setBeratersuche('personendaten.anschrift_tt', wagnis)))}
                  id="tooltip-anschrift-aendern"
                />
              </Nowrap>
            </Form.Label>
            <br />

            <TextLinkButton
              goToLink={gotoPage}
              text="Anschrift ändern"
              linkTo="ErsteDaten"
              className="mb-3"
            />
          </Form.Group>

          <Form>
            <Row className="g-1">
              <PersonAnredeFormRadio
                title="Anrede"
                onChange={updateAndValidateOnChange}
                className="col-auto"
              />
              <PersonTitelFormSelect
                title="Titel"
                onChange={updateAndValidateOnChange}
                className="col"
              />
            </Row>
            <PersonVornameFormInput
              title="Vorname"
              onChange={updateAndValidateTextOnChange}
            />
            <PersonNachnameFormInput
              title="Nachname"
              onChange={updateAndValidateTextOnChange}
            />

            <AdresseForm
              postleitzahl={vn.postleitzahl}
              postleitzahlName="daten.vn.postleitzahl.value"
              ort={vn.ort}
              ortName="daten.vn.ort.value"
              strasse={vn.strasse}
              strasseName="daten.vn.strasse.value"
              hausnummer={vn.hausnummer}
              hausnummerName="daten.vn.hausnummer.value"
            />

            <FormInput
              {...vn.zustellvermerk}
              title="Zustellvermerk"
              name="daten.vn.zustellvermerk.value"
              onChange={updateAndValidateTextOnChange}
            />

            <PersonEmailFormInput
              className="mt-4"
              onBlur={updateAndValidateOnChange}
              title="E-Mail für Rückfragen und Bestätigung"
            />
            <PersonTelefonFormInput
              title="Freiwillig: Telefon für Rückfragen"
              onChange={updateAndValidateOnChange}
            />
            <PersonGeburtsdatumFormMask
              title="Geburtsdatum"
              onChange={validateDateOnChange}
              ueberschreibbar={false}
              goToLink={vn.geburtsdatum.ueberschreibbar ? () => gotoPage('ErsteDaten') : false}
            />
          </Form>
        </div>

        <Row>
          <Col>
            <PrevNextButton
              className="d-md-none oev-show spk-show"
              onNextClick={handleNextClick}
            />
            <SpeicherButton />
          </Col>
        </Row>
      </Col>
      <SummingUp bannerImg={getBannerFileName}>
        <SummingupWarenkorb />
      </SummingUp>
    </Row>
  );
};

export default Personendaten;
